import { useLogout } from 'hooks';

const Logout: React.FunctionComponent = function () {
  useLogout();
  return <div />;
};

export default Logout;
